import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createComment(context, commentData) {
    return new Promise((resolve, reject) => {
      axios
        .post('comments', commentData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countComments(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`comments/count/?${query}`)
        .then(response => {
          context.commit('SET_COMMENT_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchComments(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`comments/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_COMMENT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchComment(context, commentId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`comments/${commentId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeComment({ commit }, commentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`comments/${commentId}`)
        .then(response => {
          commit('REMOVE_RECORD', commentId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editComment(context, comment) {
    return new Promise((resolve, reject) => {
      axios
        .put(`comments/${comment.id}`, comment.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
